<template>
  <v-content>
    <v-container>
      <list
        ref="list"
        :title="title"
        :headers="headers"
        :data="data"
        :response="response"
        :loading="loading"
        @edit="editFn"
        @delete="deleteFn"
        @details="previewFn"
        @new="newFn"
        @reload="loadItems()"
        @sort="loadItems()"
        @hook:mounted="handleMount('list')"
      />
      <delete-dialog
        :dialog="deleteDialog"
        :item="itemName"
        @agree="remove"
        v-show="false"
      />
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import List from "@/components/lists/BuilderList.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import snackbar from "@/utils/snackbar.js";
import categories from "@/utils/categories.js";

export default {
  components: {
    List,
    DeleteDialog,
  },
  data: () => ({
    mounted: {
      list: { mounted: false, refs: "list" },
      root: { mounted: false, refs: null },
    },
    headers: [],
    data: [],
    sort: "name",
    title: "Parts",
    deleteDialog: false,
    item: null,
    itemName: null,
    loading: true,
    response: null,
    categoryOptions: [],
    options: {},
  }),
  created() {
    this.setInitialData();
    this.categoryOptions = categories.categoryOptions();
  },

  mounted() {
    //NOTE: this is here to prevent multiple API calls to the same function. To gether all the parameters from the different components.
    this.handleMount("root");
  },
  methods: {
    handleMount(componentName) {
      if (!this.mounted.hasOwnProperty(componentName)) {
        console.error("ITEMS:component name does not exists", componentName);
        return;
      }

      this.mounted[componentName] = {
        ...this.mounted[componentName],
        mounted: true,
      };

      if (Object.values(this.mounted).every((item) => item.mounted)) {
        this.loadItems();
      }
    },
    setInitialData() {
      this.headers = [
        {
          text: this.$t("builder.parts.list.productName"),
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("builder.parts.list.manufacturer"),
          align: "left",
          sortable: false,
          value: "vendor.name",
        },
        {
          text: this.$t("builder.parts.list.categories"),
          align: "left",
          sortable: false,
          value: "prettified_categories",
        },
        {
          text: this.$t("builder.parts.list.sku"),
          align: "left",
          sortable: false,
          value: "sku",
        },
        {
          text: this.$t("builder.parts.list.inUse"),
          align: "left",
          orderingName: "in_use_boats",
          value: "in_use_boats",
        },
        { text: "", align: "right", value: "action", sortable: false },
      ];
      this.title = this.$t("builder.parts.list.parts");
    },
    loadItems() {
      let params = {};

      for (const key in this.mounted) {
        const refs = this.mounted[key].refs;
        if (refs == null) continue;
        params = {
          ...params,
          ...this.$refs[refs].query,
        };
      }

      this.$router.replace({
        name: this.$route.name,
        query: params,
      });

      this.loading = true;
      this.data = [];
      api.getItemList(params).then((resp) => {
        resp.data.results.forEach((element) => {
          element.prettified_categories = element.categories
            ? element.categories.map((category) => {
                const prettified_category = this.categoryOptions.find(
                  (categoryOption) => category === categoryOption.category
                );
                return prettified_category || { category };
              })
            : [];
        });
        this.response = resp.data;
        this.data = resp.data.results;
        this.loading = false;
      });
    },
    editFn(item) {
      this.$store.commit("ITEMLOADING", false);
      this.$router.push({
        name: "itemsEdit",
        params: { id: item.uuid, action: "edit" },
      });
    },
    deleteFn(item) {
      this.deleteDialog = true;
      this.item = item;
      this.itemName = item.name;
    },

    remove(agreed) {
      if (agreed) {
        api.deleteItem(this.item.uuid).then((resp) => {
          snackbar.success(
            this.$t("utils.snackbar.success.successfullyDeleted")
          );
          this.loadItems();
        });
      }
      this.deleteDialog = false;
    },
    previewFn(item) {
      this.$router.push({
        name: "itemsDetails",
        params: { id: item.uuid, action: "preview" },
      });
    },
    newFn(item) {
      this.$store.commit("ITEMLOADING", false);
      this.$router.push({
        name: "itemsAdd",
        params: { id: "-", action: "new" },
      });
    },
  },
};
</script>
